"use client";

import Link from "next/link";

import type { Brand } from "@/shared/api/services/productService";

import { ScrollCarousel } from "@/features/home/components/ScrollCarousel";
import { useHomeFeaturedBrands } from "@/features/home/queries/useHomeData";

import { Skeleton } from "@/components/ui/skeleton";

export function FeaturedBrandsSection() {
  const { data, isLoading } = useHomeFeaturedBrands();
  const brands: Brand[] = data?.data?.brands ?? [];

  if (!isLoading && brands.length === 0) return null;

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="mb-6 md:mb-8">
          <h2 className="font-heading text-base md:text-lg font-semibold tracking-tight">
            주목할 브랜드
          </h2>
        </div>

        {isLoading ? (
          <div className="flex gap-4 overflow-hidden">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="flex-shrink-0 w-[55%] md:w-[calc(20%-13px)]">
                <Skeleton className="aspect-square w-full" />
                <Skeleton className="h-4 w-2/3 mt-3" />
              </div>
            ))}
          </div>
        ) : (
          <ScrollCarousel>
            {brands.map((brand) => (
              <Link
                key={brand.id}
                href={`/brands/${brand.id}`}
                className="group flex-shrink-0 w-[55%] sm:w-[38%] md:w-[calc(20%-13px)]"
              >
                <div className="aspect-square overflow-hidden bg-neutral-100 relative">
                  {brand.thumbnail ? (
                    <img
                      src={brand.thumbnail}
                      alt={brand.name}
                      loading="lazy"
                      className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-neutral-400 text-sm">
                      {brand.name}
                    </div>
                  )}
                </div>
                <p className="mt-2.5 text-[13px] font-medium text-neutral-800 group-hover:text-neutral-500 transition-colors">
                  {brand.name}
                </p>
              </Link>
            ))}
          </ScrollCarousel>
        )}
      </div>
    </section>
  );
}
